import { all, call, put, select } from 'redux-saga/effects'
import { Capacitor } from '@capacitor/core'
import * as userProfilingApi from 'Api/userProfiling/userProfiling'
import * as personalDataApi from 'Api/personalData/personalData'
import * as userProfilingActions from 'Store/actions/userProfiling'
import { buildLoyaltyRedirectUrl, getLoyaltyAdditionalData, utmConverter } from 'Utility/globalMethods'

const getMerchantId = (state) => state.userProfiling?.profiling?.user?.merchantId || ''
const getServiceQuickLinks = (state) => state.userProfiling?.serviceQuickLinksData || {}

function * getLoyaltyQuickLinks () {
  const cachedQuickLinks = yield select(getServiceQuickLinks)
  if (cachedQuickLinks.widgets) return { data: cachedQuickLinks, fromCache: true }

  const { error, response } = yield call(userProfilingApi.getServiceQuickLinks, {})
  return { data: error ? null : response.data, fromCache: false }
}

function * getLoyaltyMerchantId () {
  const cachedMerchantId = yield select(getMerchantId)
  if (cachedMerchantId) return { merchantId: cachedMerchantId, fromCache: true }

  const { error, response } = yield call(userProfilingApi.profiling, {})
  return {
    merchantId: error ? '' : response.data?.user?.merchantId || '',
    profiling: error ? null : response,
    fromCache: false
  }
}

export function * resolveLoyaltyDestination () {
  const [quickLinksResult, consents, merchantResult] = yield all([
    call(getLoyaltyQuickLinks),
    call(personalDataApi.getConsents, {}),
    call(getLoyaltyMerchantId)
  ])

  const quickLinks = quickLinksResult.data
  const merchantId = merchantResult.merchantId
  const loyaltyAdditionalData = getLoyaltyAdditionalData(quickLinks)
  const baseUrl = loyaltyAdditionalData?.actionUrl

  if (!consents.error && consents.response?.data?.consent3Value && baseUrl && merchantId) {
    const merchantIdHashed = yield call(utmConverter, merchantId)
    const redirectUrl = yield call(buildLoyaltyRedirectUrl, {
      baseUrl,
      merchantIdHashed,
      isNativeApp: Capacitor.isNativePlatform()
    })

    if (redirectUrl) return { type: 'external', url: redirectUrl }
  }

  if (!quickLinksResult.fromCache && quickLinks) {
    yield put(userProfilingActions.getServiceQuickLinks.success(quickLinks))
  }
  if (!merchantResult.fromCache && merchantResult.profiling) {
    yield put(userProfilingActions.profiling.success(merchantResult.profiling))
  }

  return { type: 'internal', path: '/nexiclub' }
}
